import { FullProject, TaskWithSub, User, taskStatusByCode } from 'entities';

import { Dot, Row } from 'components/Blocks';
import { getUserLabel } from 'components/Inputs';

import { ListFilters } from 'components/ListManipulation/types';

export function getTaskFilters(projects: Record<string, FullProject>): ListFilters<TaskWithSub>[] {
  const filters: (ListFilters<TaskWithSub> | null)[] = [
    {
      getLabel: (t) => t('status'),

      property: 'status',

      multiple: true,

      optionExtractor: ({ status }, t) => ({
        value: status,
        name: taskStatusByCode[status].getLabel(t),
      }),

      getOptionNode: ({ name, value }) => (
        <Row gap="1.5">
          <Dot color={taskStatusByCode[value].color} />

          <span>{name}</span>
        </Row>
      ),
    },

    {
      getLabel: (t) => t('owner'),

      property: 'owner',

      multiple: true,

      optionExtractor: ({ owner }) => ({
        ...owner,
        value: owner.id,
      }),

      getOptionNode: (user) => getUserLabel(user as unknown as User),
    },

    {
      getLabel: (t) => t('sub-owner'),

      property: 'subOwner',

      multiple: true,

      optionExtractor: ({ subOwner }) =>
        subOwner
          ? [
              {
                ...subOwner,
                value: subOwner.id,
              },
            ]
          : [],

      getOptionNode: (user) => getUserLabel(user as unknown as User),
    },

    {
      getLabel: (t) => t('tags'),

      property: 'tags',

      multiple: true,

      optionExtractor: ({ tags }) =>
        tags.map(({ tag }) => ({
          ...tag,
          value: tag.id,
        })),

      getOptionNode: ({ name, color }) => (
        <Row gap="1.5">
          <Dot color={color} />

          <span>{name}</span>
        </Row>
      ),
    },

    {
      getLabel: (t) => t('client'),

      property: 'projectId',

      multiple: true,

      optionExtractor: ({ projectId }) => ({
        value: projects[projectId].client,
        name: projects[projectId].clientName,
      }),
    },
  ];

  return filters.filter(Boolean) as ListFilters<TaskWithSub>[];
}
